import Actions from "./Actions";
import Records from "./Records";

const Entries = () => {
  return (
    <div className="h-full px-8 w-full">
      <Records />
    </div>
  );
};
export default Entries;
